import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { whatsappUrl } from '../content/siteContent';

const { FiMessageCircle } = FiIcons;

function FloatingWhatsApp() {
  return (
    <a
      className="floating-whatsapp"
      href={whatsappUrl()}
      target="_blank"
      rel="noreferrer"
      aria-label="Pedir un mandao por WhatsApp"
    >
      <SafeIcon icon={FiMessageCircle} />
      <span>Pedir mandao</span>
    </a>
  );
}

export default FloatingWhatsApp;